import {
  Stack,
  TextField,
  ToggleButtonGroup,
  ToggleButton,
} from '@mui/material';

export enum DimentionTypes {
  PERCENTAGE = '%',
  PIXELS = 'px',
}

interface FieldProps {
  label: string;
  value: string;
  setValue: (e: any) => void;
  type: DimentionTypes;
  setType: (type: DimentionTypes) => void;
}

const DimentionField = ({
  label,
  value,
  setValue,
  type,
  setType,
}: FieldProps) => {
  const handleType = (_: React.MouseEvent<HTMLElement>, type: DimentionTypes) => {
    setType(type);
  };

  const handleValue = (e: any) => {
    setValue(e.target.value);
  };

  return (
    <Stack direction="row" spacing={2}>
      <TextField
        label={label}
        size="small"
        fullWidth
        value={value}
        onChange={handleValue}
      />
      <ToggleButtonGroup
        exclusive
        value={type ?? DimentionTypes.PIXELS}
        size="small"
        color="primary"
        onChange={handleType}
      >
        <ToggleButton
          value="%"
          size="small"
          aria-label="centered"
          sx={{ width: 50 }}
        >
          %
        </ToggleButton>
        <ToggleButton
          value="px"
          size="small"
          aria-label="centered"
          sx={{ width: 50 }}
        >
          px
        </ToggleButton>
      </ToggleButtonGroup>
    </Stack>
  );
};

export default DimentionField;
